import React, {useEffect} from 'react';
import {Platform} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {useQueryParam, StringParam} from 'use-query-params';

import {initRemoteConfig} from 'store/app/remoteConfigActions';
import {initDynamicLinkHandler} from 'store/app/linkActions';
import {initCache} from 'store/app/cacheActions';
import {redirectToWebHome} from 'utils/webRedirects';
import {
  setLegacyFlag,
  setDirectLanding,
  setReadyToMove,
  setAvatarURL,
  setCustomCourse,
} from 'store/meeting/actions/meeting';
import {setCurrentUnitId} from './store/course';

const RemoteConfigHandler = () => {
  const dispatch = useDispatch();
  const isRemoteConfigLoaded = useSelector(
    state => state.app.isRemoteConfigLoaded,
  );

  useEffect(() => {
    if (Platform.OS === 'web') {
      if (!isRemoteConfigLoaded) {
        dispatch(initRemoteConfig());
      }
    }
  }, [isRemoteConfigLoaded]); // Add token to dependencies to ensure correctness

  // Web breaks for some reason using useEffect to call this
  console.log('RemoteConfigHandler', Date.now());

  return <></>;
};
const IntialLink = () => {
  const dispatch = useDispatch();
  const [token] = useQueryParam('token', StringParam);
  const [avatarSelectionString] = useQueryParam('avatarSelection', StringParam);
  const [avatarUrlString] = useQueryParam('avatarUrl', StringParam);
  const [customCourseString] = useQueryParam('customCourse', StringParam);
  const [showTrialDemo] = useQueryParam('showTrialDemo', StringParam);
  const [showLVDemo] = useQueryParam('showLVDemo', StringParam);

  // avatarSelection
  if (Platform.OS === 'web' && token) {
    const avatarSelection = avatarSelectionString === 'true'; // 'true' becomes true, everything else becomes false
    // Legacy is fully deprecated: always run in non-legacy mode, regardless of URL params.
    const legacy = false;
    if (avatarUrlString) {
      dispatch(setAvatarURL(`${avatarUrlString}`));
    }
    const customCourse = customCourseString === 'true';
    dispatch(setDirectLanding(!avatarSelection));
    dispatch(setCustomCourse(customCourse));
    dispatch(setReadyToMove(false));
    dispatch(setLegacyFlag(legacy));
    // Always executes once for web; demo flags are optionally used by link handler.
    dispatch(initDynamicLinkHandler(token, avatarSelection, showTrialDemo, showLVDemo));
    return <></>;
  }

  // Trial demo entry point (web): if we have demo params but no token, run the TrialDemo flow
  if (Platform.OS === 'web' && (showTrialDemo || showLVDemo)) {
    // Dev/prod deployments don't run the demo-login pipeline; just send user home.
    redirectToWebHome({replace: true});
    return <></>;
  }
  return <></>;
};
export default () => {
  return (
    <>
      <RemoteConfigHandler />
      <IntialLink />
    </>
  );
};
